export enum DeleteStripePaymentMethodActionTypes {
  DELETE_STRIPE_PAYMENT_METHOD_REQUEST = 'payment/DELETE_STRIPE_PAYMENT_METHOD_REQUEST',
  DELETE_STRIPE_PAYMENT_METHOD_SUCCESS = 'payment/DELETE_STRIPE_PAYMENT_METHOD_SUCCESS',
  DELETE_STRIPE_PAYMENT_METHOD_ERROR = 'payment/DELETE_STRIPE_PAYMENT_METHOD_ERROR',
}
